var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{staticClass:"my-header"}),_c('keep-alive',{staticStyle:{"margin-top":"60px"}},[_c('router-view')],1),_c('Footer',{staticClass:"my-footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }